// Views
import { Dashboard } from "views/Dashboard";

import { accountTypesConstants } from "../constants";
import { gisRoutes } from './routes';
import phrasebookLoad from "../i18n";
const phrasebook = phrasebookLoad()

const dashboardRoutes = [

  {
    path: gisRoutes.dashboard.administrator,
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.ADMINISTRATOR,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.admin_dashboard
  },
  {
    path: gisRoutes.dashboard.pccwglobal_sales,
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.PCCW_SALES,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.pccwg_sales_dashboard
  },
  {
    path: gisRoutes.dashboard.pccwglobal_product,
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.PCCW_PRODUCT,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.pccwg_product_dashboard
  },
  {
    path: gisRoutes.dashboard.pccwglobal_billing,
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.PCCW_BILLING,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.pccwg_billing_dashboard
  },
  {
    path: gisRoutes.dashboard.pccwglobal_operation,
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.PCCW_OPERATION,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.pccwg_operation_dashboard
  },


  {
    path: gisRoutes.dashboard.master,
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.MASTER,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.master_dashboard
  },
  {
    path: gisRoutes.dashboard['sub-account-sales'],
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.SUB_ACCOUNT_SALES,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.sub_account_dashboard
  },
  {
    path: gisRoutes.dashboard['sub-account-product'],
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.SUB_ACCOUNT_PRODUCT,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.sub_account_dashboard
  },
  {
    path: gisRoutes.dashboard['sub-account-operation'],
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.SUB_ACCOUNT_OPERATION,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.sub_account_dashboard
  },
  {
    path: gisRoutes.dashboard['sub-account-billing'],
    component: Dashboard,
    routeType: 'portal',
    restrictedAccount: accountTypesConstants.SUB_ACCOUNT_BILLING,
    type: 'logo',
    category: 'dashboard',
    name: phrasebook.labels.sub_account_dashboard
  },
]


export default dashboardRoutes;
